// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog__loader[data-v-ea47a8c6]{width:100%;height:250px;display:flex;align-items:center;justify-content:center}.dialog__serial-number[data-v-ea47a8c6]{color:#ff002b;margin-left:8px}", ""]);
// Exports
module.exports = exports;
